import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance23prvj6kllmmf as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.l3w_1 = 8192;
        this.m3w_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.o3w_1 = 0;
  _this__u8e3s4.p3w_1 = 0;
  _this__u8e3s4.q3w_1 = false;
  _this__u8e3s4.r3w_1 = false;
  _this__u8e3s4.s3w_1 = null;
  _this__u8e3s4.t3w_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static u3w() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.n3w_1 = new Int8Array(8192);
        $this.r3w_1 = true;
        $this.q3w_1 = false;
        return $this;
      }
      static v3w(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.n3w_1 = data;
        $this.o3w_1 = pos;
        $this.p3w_1 = limit;
        $this.q3w_1 = shared;
        $this.r3w_1 = owner;
        return $this;
      }
      w3w() {
        this.q3w_1 = true;
        return Segment().v3w(this.n3w_1, this.o3w_1, this.p3w_1, true, false);
      }
      x3w() {
        var result = !(this.s3w_1 === this) ? this.s3w_1 : null;
        ensureNotNull(this.t3w_1).s3w_1 = this.s3w_1;
        ensureNotNull(this.s3w_1).t3w_1 = this.t3w_1;
        this.s3w_1 = null;
        this.t3w_1 = null;
        return result;
      }
      y3w(segment) {
        segment.t3w_1 = this;
        segment.s3w_1 = this.s3w_1;
        ensureNotNull(this.s3w_1).t3w_1 = segment;
        this.s3w_1 = segment;
        return segment;
      }
      z3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.p3w_1 - this.o3w_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.w3w();
        } else {
          prefix = SegmentPool_instance.c3x();
          var tmp0 = this.n3w_1;
          var tmp2 = prefix.n3w_1;
          var tmp5 = this.o3w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.o3w_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.p3w_1 = prefix.o3w_1 + byteCount | 0;
        this.o3w_1 = this.o3w_1 + byteCount | 0;
        ensureNotNull(this.t3w_1).y3w(prefix);
        return prefix;
      }
      d3x() {
        // Inline function 'kotlin.check' call
        if (!!(this.t3w_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.t3w_1).r3w_1)
          return Unit_instance;
        var byteCount = this.p3w_1 - this.o3w_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.t3w_1).p3w_1 | 0) + (ensureNotNull(this.t3w_1).q3w_1 ? 0 : ensureNotNull(this.t3w_1).o3w_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.e3x(ensureNotNull(this.t3w_1), byteCount);
        this.x3w();
        SegmentPool_instance.f3x(this);
      }
      e3x(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.r3w_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.p3w_1 + byteCount | 0) > 8192) {
          if (sink.q3w_1)
            throw IllegalArgumentException().od();
          if (((sink.p3w_1 + byteCount | 0) - sink.o3w_1 | 0) > 8192)
            throw IllegalArgumentException().od();
          var tmp0 = sink.n3w_1;
          var tmp2 = sink.n3w_1;
          var tmp5 = sink.o3w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.p3w_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.p3w_1 = sink.p3w_1 - sink.o3w_1 | 0;
          sink.o3w_1 = 0;
        }
        var tmp0_0 = this.n3w_1;
        var tmp2_0 = sink.n3w_1;
        var tmp4 = sink.p3w_1;
        var tmp6 = this.o3w_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.o3w_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.p3w_1 = sink.p3w_1 + byteCount | 0;
        this.o3w_1 = this.o3w_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.u3w);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
